<template>
  <div id="contenedor-focoscalor" v-show="isHiddenRender">
    <div class="contenedorefechas">
      <label for="startDate" slot="before" class="labelsdate">Fecha Inicio</label>

      <datetime
          input-id="startDate" format="yyyy-MM-dd HH:mm:ss"
          ref="startdatetime"
          v-model="fechainicial"
          type="datetime"
          placeholder="Seleccionar Fecha"
          @click="openDatetimestartdatetime"
          value-zone="UTC-4">
        <template slot="button-cancel">
          <i class="fa fa-times"/>
          Cerrar
        </template>
        <template slot="button-confirm">
          <i class="fa fa-check-circle"/>
          Continuar
        </template>
      </datetime>
    </div>

    <div class="contenedorefechas">
      <label for="endDate" slot="before" class="labelsdate">Fecha Final</label>

      <datetime
          input-id="endDate" format="yyyy-MM-dd HH:mm:ss"
          ref="enddatetime"
          v-model="fechafinal"
          type="datetime"
          placeholder="Seleccionar Fecha"
          @click="openDatetimeenddatetime"
          value-zone="UTC-4"
      >
        <template slot="button-cancel">
          <i class="fa fa-times"/>
          Cerrar
        </template>
        <template slot="button-confirm">
          <i class="fa fa-check-circle"/>
          Continuar
        </template>
      </datetime>
    </div>

    <div class="contenedorefechas">
      <label class="labelsdate">Color</label>

      <v-input-colorpicker id="color-marker" v-model="color" />
    </div>

  </div>

</template>
<script>
import Vue from 'vue';
import {Datetime} from 'vue-datetime';
import {Settings} from 'luxon'
import VueSweetalert2 from 'vue-sweetalert2';
import InputColorPicker from 'vue-native-color-picker'
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2);

Settings.defaultLocale = 'es'
export default {
  name: "DateHourColorPicker",
  components: {
    "datetime": Datetime,
    "v-input-colorpicker": InputColorPicker
  },
  props: ['isHiddenRender'],
  data() {
    return {
      fechainicial: null,
      fechafinal: null,
      startdate: false,
      color: "#0f4c81",
    }
  },
  methods: {
    aplicarcapaRango() {
      this.$parent.createCapa();
    },
    openDatetimestartdatetime() {
      this.$refs.startdatetime.isOpen = true;
    },
    openDatetimeenddatetime() {
      if (this.fechainicial == '') {
        this.showAlert();
      } else {
        this.$refs.enddatetime.isOpen = true;
      }
    },
    showAlert() {
      // Use sweetalert2
      this.$swal.fire({
        title: 'Fecha final',
        text: 'Debe selecionar primero la fecha inicial',
        icon: 'error',
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: 'Cerrar',
        cancelButtonColor: '#d33',
      });
    },
    showAlertDays() {
      // Use sweetalert2
      this.$swal.fire({
        title: 'Rango no valido',
        text: 'No mayor a 30 días',
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Cerrar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.fechainicial = '';
          this.fechafinal = '';
        }
      })

    },
    checkdiffrent: function () {
      //fecha inicial
      if (this.fechainicial !== '' && this.fechafinal !== '') {
        var fechainicial = this.fechainicial;
        fechainicial = fechainicial.replace('Z', ' ').replace('T', ' ').replace('-04:00', '');
        let dateToConvert = fechainicial;
        let datex = new Date(dateToConvert);
        let timestampfechainicial = datex.getTime();
        //fecha final
        var fechafinal = this.fechafinal;
        fechafinal = fechafinal.replace('Z', ' ').replace('T', ' ').replace('-04:00', '');
        let dateToConvertFinaldate = fechafinal;
        let datefinal = new Date(dateToConvertFinaldate);
        let timestampfechaFinal = datefinal.getTime();

        const date1Str = timestampfechainicial;
        const date2Str = timestampfechaFinal;
        const diffTime = Math.abs(date2Str - date1Str);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays > 31) {
          this.showAlertDays();
        }
      }
    },
    onClickOut() {
      if (this.noCloseOnBackdrop) return
    }
  },
  mounted() {
    var stardate = document.querySelector('#startDate');
    stardate.readOnly = true;
    stardate.style.textAlign = 'center';
    stardate.style.marginTop = '3px';
    stardate.style.color = '#212121';
    stardate.style.fontSize = '0.70rem';
    stardate.style.borderRadius = '5px';
    var endDate = document.querySelector('#endDate');
    endDate.readOnly = true;
    endDate.style.textAlign = 'center';
    endDate.style.marginTop = '3px';
    stardate.style.fontSize = '0.70rem';
    endDate.style.color = '#212121';
    endDate.style.borderRadius = '5px';
  },
  watch: {
    fechainicial: function (val) {
      if (val !== '') {
        this.checkdiffrent();
      }
    },
    fechafinal: function (val) {
      if (val !== '') {
        this.checkdiffrent();
      }
    }
  }
}
</script>
<style scoped lang="scss">
.contenedorefechas {
  display: flex;
  text-align: left;
}

.labelsdate {
  font-family: "Open Sans";
  color: #212121;
  font-size: 0.70rem;
  font-weight: 200;
  width: 30%;
}

#contenedor-focoscalor {
  text-align: left;
  display: flex;
  align-items: left;
  flex-direction: column;
  font-size: 0.70rem;
  margin-top: 10px;
  border: 0.5px solid #ECF0F1;
  background: #ECF0F1;
  border-radius: 10px;
  padding-top: 10px;
  margin-bottom: 10px;
}

#contenedor-focoscalor label {
  padding: 5px;
}

#titulo_focos_calor {
  text-align: center;
}

#startDate {
  text-align: center;
  width: 75px;
}

#endDate {
  text-align: center;
  width: 75px;
}

.theme-orange .vdatetime-popup.vdatetime-popup__header {
  padding: 18px 30px;
  background: #ccced9 !important;
  color: #fff;
  font-size: 32px;
}

.theme-orange .vdatetime-popup__header,
.theme-orange .vdatetime-calendar__month__day--selected > span > span,
.theme-orange .vdatetime-calendar__month__day--selected:hover > span > span {
  background: #FF9800;
}

.theme-orange .vdatetime-year-picker__item--selected,
.theme-orange .vdatetime-time-picker__item--selected,
.theme-orange .vdatetime-popup__actions__button {
  color: #ff9800;
}

.button.is-primary {
  background-color: #23841f !important;
  border-color: transparent;
  color: #fff;
  padding: 5px;
  padding-right: 5px;
  padding-left: 5px;
  margin-bottom: 9px;
  font-size: 0.75rem;
  padding-left: 5px;
  padding-right: 5px;
}

.button.is-primary:hover, .button.is-primary.is-hovered {
  background-color: #23841f !important;
  border-color: transparent;
  color: #fff;
}
</style>